import { AlertCircle } from 'lucide-react';

interface Blindspot {
  type: string;
  alert: string;
}

interface BlindspotCardsProps {
  data: Blindspot[];
}

export default function BlindspotCards({ data }: BlindspotCardsProps) {
  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold text-slate-800 mb-4">Blindspot Alerts</h3>
      <div className="space-y-4">
        {data.map((item, index) => (
          <div key={index} className="p-4 bg-amber-50 border-l-4 border-amber-400 rounded-r-lg">
            <div className="flex">
              <div className="flex-shrink-0">
                <AlertCircle className="h-5 w-5 text-amber-500" />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-amber-800">{item.type}</p>
                <p className="mt-1 text-sm text-amber-700">{item.alert}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
